import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { nFormatter, numToPercent } from '../../utils';

interface KpiCardProps {
  title: string;
  caption?: string;
  chart?: any;
  value: number;
  loading: boolean;
  percent?: boolean;
}

export const KpiCard = ({
  title,
  caption,
  value,
  loading,
  percent = false,
  chart,
}: KpiCardProps) => {
  return (
    <Paper elevation={5} sx={{ height: '100%' }}>
      <Grid
        container
        // display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        padding={2}
        sx={{ height: '100%' }}
      >
        <Grid item>
          <Typography
            variant="h6"
            style={{
              textTransform: 'uppercase',
              marginBottom: 4,
            }}
          >
            {title}
          </Typography>
        </Grid>
        <Grid item justifyContent={'center'}>
          <Typography variant="h4" color={'secondary'}>
            {loading ? (
              <CircularProgress size={18} />
            ) : chart ? (
              <>{chart}</>
            ) : (
              <React.Fragment>
                {percent
                  ? `${numToPercent(value || 0)}`
                  : `$${nFormatter(value || 0)}`}
              </React.Fragment>
            )}
          </Typography>
        </Grid>
        <Grid item>
          {caption && (
            <Typography
              variant="caption"
              style={{
                textTransform: 'uppercase',
                marginBottom: 4,
              }}
            >
              {caption}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
